//import "core-js/stable"
import "regenerator-runtime/runtime"

import React from "react"
import ReactDOM from "react-dom"
import { Router, Route, Switch, Redirect } from "react-router-dom"
import AjaxService from "@/services/ajax-service"

import history from "./config-history"

import "@sogei/react-web-components-catalog/dist/css/uikit.css"
import "@sogei/react-web-components-catalog/dist/css/uikit/agenzia-entrate.css"
import "Css/app.css"


import {
    AuthHeader,
    AuthFooter,
    AuthMenu,
    Spinner,
    Messages
} from "@/containers/layout"
import MessageHandler from "@/containers/ui"

import {
    onRequestConfig,
    onRequestConfigError,
    onResponse,
    onResponseError,
    onNoServerResponse
} from "@/services/network-config"
import { serviceWorker } from "./serviceWorker"
import Main from "./components/main/Main"
import NotFound from "./components/main/NotFound"
import MultiAnnoProvider from "./context/MultiAnnoContext"

const service = new AjaxService(
    onRequestConfig,
    onRequestConfigError,
    onResponse,
    onResponseError,
    onNoServerResponse
)

const frameworkTitle = <>Context API</>

const frameworkBodyContent = (
    <p>
        Le Context API <i className="fas fa-globe-europe" /> sono utili per
        passare dati attraverso tutto l&apos;albero dei componenti, senza
        doverli passare manualmente ad ogni livello intermedio.
    </p>
)

const frameworkFooterContent = (
    <a
        target="_blank"
        rel="noreferrer"
        href="https://it.reactjs.org/docs/context.html"
    >
        Context API
        <i className="fas fa-arrow-down ml-2" />
    </a>
)

const App = (): JSX.Element => {
    return (
        <MessageHandler history={history} service={service}>
            <MultiAnnoProvider>
                <AuthHeader />
                <AuthMenu />
                <Spinner />
                <Messages extraClass={["container-fluid", "py-3", "py-md-4"]} />
                <main role="main" id="main">
                    <Switch>
                        <Route exact path={process.env.CONTEXT_PATH + "/"}>
                            <Redirect to={process.env.CONTEXT_PATH + "/home"} />
                        </Route>
                        <Route exact path={"/"}>
                            <Redirect to={process.env.CONTEXT_PATH + "/home"} />
                        </Route>
                        <Route
                            path={process.env.CONTEXT_PATH + "/home"}
                            exact
                            component={Main}
                        />
                        {/* <Route component={NotFound} /> */}
                        <Route component={NotFound} />

                        <Route path="*" component={NotFound} />
                    </Switch>
                    <AuthFooter />
                </main>
            </MultiAnnoProvider>
        </MessageHandler>
    )
}

ReactDOM.render(
    <Router history={history}>
        <App />
    </Router>,
    document.getElementById("root")
)

serviceWorker.unregister()
